import styled from 'styled-components';
import { ImagePlaceholder } from './icon';
import { Vehicle } from '../../../../types/vehicle';
import { ADMIN_VEHICLE_LABELS, VEHICLE_STATUSES } from '../../../../constants';
import { useCurrentUser } from 'hooks/selectors';
import { useHistory } from 'react-router-dom';

const VehicleImageWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 158px;
  height: auto;
  background: rgba(217, 217, 217, 1);
  border: 0.5px solid rgba(217, 217, 217, 1);
  border-radius: 20px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 20px;
  }

  @media (orientation: landscape) {
    width: 140px;
    height: 105px;
  }

  @media (min-width: 1200px) {
    width: 160px;
    height: 120px;
  }
`;

const RoundedStatus = styled.div<{ background: string }>`
  border-radius: 20px;
  color: #fff;
  background: ${props => props.background};
  font-size: 10px;
  font-weight: 600;
  line-height: 11.72px;
  padding: 8px;
  position: absolute;
  top: 4px;
  right: 4px;
  text-transform: capitalize;
`;

const IDWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 14px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  background: #fff;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  gap: 2px;

  font-size: 10px;
  font-weight: 400;
  line-height: 11.72px;
  color: rgba(117, 117, 117, 1);
`;

const IDNumber = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 11.72px;
  color: #000;
`;

const ListerBar = styled.div`
  height: calc(100% - 30px);
  margin: auto;

  width: 2px;
  background: ${props => props.bg};
`;

type Props = { vehicle: Vehicle };

const getStatusColor = (status: string) => {
  if (status === 'active' || status === 'awarded') {
    return 'rgba(21, 182, 132, 1)';
  }

  if (status === 'pulled' || status === 'deactivated') {
    return '#D50808';
  }

  return '#e47E00';
};

const getStatusLabel = (status: string) => {
  if (status === VEHICLE_STATUSES.UNDER_REVIEW) {
    return 'Under Review';
  }

  return status;
};

const Container = styled.div`
  display: flex;
`;

export const ImageComponent = ({ vehicle }: Props) => {
  const color = getStatusColor(vehicle.status);
  const label = getStatusLabel(vehicle.status);

  const imageSrc = vehicle.preview_image?.url;

  const user = vehicle.user;

  const currentUser = useCurrentUser();
  const isAdmin = currentUser.job_title === 'Admin';

  const history = useHistory();
  const handleClick = () => history.push(`/vehicles/${vehicle.id}/view`);

  const bg = (() => {
    if (!isAdmin || !user?.referrer_user?.options?.color) return 'transparent';
    return user?.referrer_user?.options?.color;
  })();

  return (
    <Container onClick={handleClick}>
      <ListerBar bg={bg} />
      <VehicleImageWrapper>
        {imageSrc ? <img src={imageSrc} /> : <ImagePlaceholder />}
        <RoundedStatus background={color}>{label}</RoundedStatus>
        {vehicle.auction && (
          <IDWrapper>
            <span>ID:</span>
            <IDNumber>
              {vehicle.auction.slug.replace('-', '')}
              {vehicle.orderIndex ? `#${vehicle.orderIndex}` : ''}
            </IDNumber>
          </IDWrapper>
        )}
      </VehicleImageWrapper>
    </Container>
  );
};
